import type {
  WidgetCardRadius,
  WidgetCardShadowDirection,
  WidgetCarouselIntervalSeconds,
  WidgetCarouselTransition,
  WidgetCarouselTransitionDurationMs,
  WidgetCount,
  WidgetFormat,
  WidgetMinRating,
  WidgetPlatform,
} from "../contracts/widgets/common";

export type {
  WidgetCardRadius,
  WidgetCardShadowDirection,
  WidgetCarouselIntervalSeconds,
  WidgetCarouselTransition,
  WidgetCarouselTransitionDurationMs,
  WidgetCount,
  WidgetFormat,
  WidgetMinRating,
  WidgetMode,
  WidgetPlatform,
} from "../contracts/widgets/common";

export const WIDGET_FORMATS = [
  "carousel",
  "grid",
  "list",
] as const satisfies readonly WidgetFormat[];

export const WIDGET_MIN_RATINGS = [4, 5] as const satisfies readonly WidgetMinRating[];

export const WIDGET_COUNTS = [5, 10, 15] as const satisfies readonly WidgetCount[];

export const WIDGET_PLATFORMS = ["google"] as const satisfies readonly WidgetPlatform[];

export const WIDGET_CAROUSEL_TRANSITIONS = [
  "slide",
  "fade",
  "zoom",
] as const satisfies readonly WidgetCarouselTransition[];

export const WIDGET_CAROUSEL_TRANSITION_DURATIONS = [
  300, 600, 900, 1200, 1600, 2000,
] as const satisfies readonly WidgetCarouselTransitionDurationMs[];

export const WIDGET_CAROUSEL_INTERVALS = [
  1, 2, 3, 4, 5, 6,
] as const satisfies readonly WidgetCarouselIntervalSeconds[];

export const WIDGET_CARD_RADII = [
  "none",
  "sm",
  "md",
  "lg",
  "xl",
] as const satisfies readonly WidgetCardRadius[];

export const WIDGET_DEFAULT_CARD_RADIUS: WidgetCardRadius = "md";

export const WIDGET_CARD_BORDER_WIDTH_MIN = 0;
export const WIDGET_CARD_BORDER_WIDTH_MAX = 8;
export const WIDGET_DEFAULT_CARD_BORDER_WIDTH = 1;

export const WIDGET_CARD_SHADOW_SIZE_MIN = 0;
export const WIDGET_CARD_SHADOW_SIZE_MAX = 40;
export const WIDGET_DEFAULT_CARD_SHADOW_SIZE = 0;

export const WIDGET_CARD_SHADOW_DIRECTIONS = [
  "top",
  "bottom",
  "left",
  "right",
] as const satisfies readonly WidgetCardShadowDirection[];

export const WIDGET_DEFAULT_CARD_SHADOW_DIRECTIONS: readonly WidgetCardShadowDirection[] = [
  "bottom",
];

export const WIDGET_DEFAULT_CAROUSEL_TRANSITION: WidgetCarouselTransition = "slide";

export const WIDGET_DEFAULT_CAROUSEL_INTERVAL_SECONDS: WidgetCarouselIntervalSeconds = 6;

export const WIDGET_DEFAULT_CAROUSEL_TRANSITION_DURATION_MS: WidgetCarouselTransitionDurationMs = 1200;
